package com.tovtalk.utils.format

/**
 * Format count for display (1.2K, 1.5M).
 * Shared across Android, Web, iOS.
 */
fun formatCount(count: Long): String = when {
    count >= 1_000_000 -> "${count / 1_000_000}.${(count % 1_000_000) / 100_000}M"
    count >= 1_000 -> "${count / 1_000}.${(count % 1_000) / 100}K"
    else -> count.toString()
}
